import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'implto-toast',
  template: '<p-toast></p-toast>',
  styleUrls: ['./toast.component.scss'],
  imports: [ToastModule],
})
export class ToastComponent {}
